'use client'

import type { ReactNode } from 'react'

import { carouselRecipe } from './recipe'
import { useCarousel } from './use-carousel'

const SLIDES_TO_SHOW = 3
const CELL_SPACING = 10

type CarouselProps = {
    children: ReactNode[]
}

export function Carousel({ children }: CarouselProps) {
    const slidesToShow = SLIDES_TO_SHOW
    const cellSpacing = CELL_SPACING
    const totalSlides = children.length

    const { canGoPrevious, canGoNext, goToNext, goToPrevious, getTransformStyle } = useCarousel({
        totalSlides,
        slidesToShow,
    })

    const showControls = totalSlides > slidesToShow
    const slideWidth = 100 / slidesToShow

    const styles = carouselRecipe()
    const leftButtonStyles = carouselRecipe({ direction: 'left' })
    const rightButtonStyles = carouselRecipe({ direction: 'right' })

    return (
        <div className={styles.root}>
            {showControls && canGoPrevious && (
                <button
                    type="button"
                    className={leftButtonStyles.button}
                    onClick={goToPrevious}
                    aria-label="Previous slide"
                >
                    <i className="fa-solid fa-chevron-left" />
                </button>
            )}

            <div className={styles.viewport}>
                <div className={styles.track} style={getTransformStyle()}>
                    {children.map((child, index) => (
                        <div
                            key={index}
                            className={styles.slide}
                            style={{
                                flex: `0 0 calc(${slideWidth}% - ${cellSpacing}px)`,
                                marginRight: index < totalSlides - 1 ? `${cellSpacing}px` : 0,
                            }}
                        >
                            {child}
                        </div>
                    ))}
                </div>
            </div>

            {showControls && canGoNext && (
                <button type="button" className={rightButtonStyles.button} onClick={goToNext} aria-label="Next slide">
                    <i className="fa-solid fa-chevron-right" />
                </button>
            )}
        </div>
    )
}
